import { string } from 'yup';

import { durationToMinutes } from '~/utils/date/duration';
import {
  CE_INVALID_DURATION,
  CE_MAX_HOURS,
  CE_MIN_MINUTES,
  MINUTES_PER_HOUR,
} from '~/ui/constants/communityEngagement';

export const isCeDuration = (value: string | undefined, maxHours: number): boolean => {
  if (!value?.trim()) return true;
  const minutes = durationToMinutes(value);
  return minutes !== null && minutes >= CE_MIN_MINUTES && minutes <= maxHours * MINUTES_PER_HOUR;
};

const ceDuration = () =>
  string().test('ce-duration', CE_INVALID_DURATION, value => isCeDuration(value, CE_MAX_HOURS));

export default ceDuration;
